/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 7/5/19.
 */

angular.module('prism-ui.deliveryProfiles').service('AudioChannelMappingService',
    function (this: JS5Object) {
    const AUDIO_MAPPING_TYPE = 'AUDIO';
    const VIDEO_MAPPING_TYPE = 'VIDEO';
    const DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX = 1;

    let deliveryItem: JS5Object;
    let videoChannelMapGroup: JS5Object;

    let revertDataCallbacks: JS5Function[] = [];
    this.audioChannelMapGroups = [];


    //===================//
    // Data Revert Event //
    //===================//

    this.registerRevertDataCallback = (callbackFunc: JS5Function) => {
        if (typeof(callbackFunc) === 'function') {
            if (!_.includes(revertDataCallbacks, callbackFunc)) {
                revertDataCallbacks.push(callbackFunc);
            }
        }
    };

    this.unregisterRevertDataCallback = (callbackFunc: JS5Function) => {
        _.pull(revertDataCallbacks, callbackFunc);
    };

    const notifyRevertDataListeners = () => {
        _.forEach(_.clone(revertDataCallbacks), (callback: JS5Function) => {
            callback();
        });
    };


    //=================================//
    // Audio Channel Map Change Events //
    //=================================//

    this.onChannelUpdate = (
        outputChannelOwner: JS5Object,
        outputChannel: string
    ) => {
        this.getChannelGroupFromOutputChannel.cache.delete(outputChannel);
    };

    const _getChannelGroupFromOutputChannel = (outputChannel: string) => {
        for (let index in deliveryItem.audioChannelMapGroups) {
            let group = deliveryItem.audioChannelMapGroups[index];
            if (_.find(group.audioChannelMaps, {output: outputChannel})) {
                return group;
            }
        }
        return null;
    };

    this.getChannelGroupFromOutputChannel = _.memoize(_getChannelGroupFromOutputChannel);

    const clearCacheForChannelGroup = (channelMappingGroup: JS5Object) => {
        _.forEach(channelMappingGroup.audioChannelMaps, (channelMap: JS5Object) => {
            this.getChannelGroupFromOutputChannel.cache.delete(channelMap.output);
        });
    };

    //==============================//
    // Audio Channel Map Management //
    //==============================//

    const onChannelGroupChanged = () => {
        let newAudioMapGroups = _.filter(deliveryItem.audioChannelMapGroups, {type: AUDIO_MAPPING_TYPE});
        _.forEach(deliveryItem.audioChannelMapGroups, (channelMappingGroup: JS5Object, index: number) => {
            channelMappingGroup.index = index;
        });
        this.audioChannelMapGroups.splice(0, this.audioChannelMapGroups.length, ...newAudioMapGroups);
    };

    const createChannelMappingGroup = (mappingType: string, index: number) => {
        let newChannelMappingGroup: JS5Object = {
            type: mappingType,
            audioChannelMaps: [],
            index: index
        };
        if (mappingType === AUDIO_MAPPING_TYPE) {
            index += DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX;
            newChannelMappingGroup.index = index;
        }
        deliveryItem.audioChannelMapGroups.splice(index, 0, newChannelMappingGroup);
        return newChannelMappingGroup;
    };

    this.getChannelMappingGroup = (mappingType: string, index: number) => {
        if (mappingType === VIDEO_MAPPING_TYPE) {
            return videoChannelMapGroup;
        }
        return this.audioChannelMapGroups[index];
    };

    this.addAudioSidecar = () => {
        createChannelMappingGroup(AUDIO_MAPPING_TYPE, this.audioChannelMapGroups.length);
        onChannelGroupChanged();
    };

    this.swapAudioSidecars = (fromAudioChannelGroupIndex: number, toAudioChannelGroupIndex: number) => {
        let fromAudioChannel = this.audioChannelMapGroups[fromAudioChannelGroupIndex];
        let toAudioChannel = this.audioChannelMapGroups[toAudioChannelGroupIndex];
        if (_.isNil(fromAudioChannel) || _.isNil(toAudioChannel) || fromAudioChannel === toAudioChannel) {
            return;
        }
        let fromArrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, fromAudioChannel);
        let toArrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, toAudioChannel);
        if (fromArrayIndex < 0 || toArrayIndex < 0) {
            return;
        }

        deliveryItem.audioChannelMapGroups.splice(fromArrayIndex, 1, toAudioChannel);
        deliveryItem.audioChannelMapGroups.splice(toArrayIndex, 1, fromAudioChannel);
        onChannelGroupChanged();
    };

    this.removeAudioSidecar = (audioChannelGroupIndex: number) => {
        let arrayIndex = _.findIndex(deliveryItem.audioChannelMapGroups, {
            type: 'AUDIO',
            index: audioChannelGroupIndex +DEFAULT_AUDIO_CHANNEL_GROUP_STARTING_INDEX
        });
        if (arrayIndex < 0) {
            return;
        }
        let removedAudioChannelGroup = deliveryItem.audioChannelMapGroups.splice(arrayIndex, 1);
        clearCacheForChannelGroup(removedAudioChannelGroup[0]);
        onChannelGroupChanged();
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.setDeliveryItem = (_deliveryItem_: JS5Object) => {
        deliveryItem = _deliveryItem_;
        if (!_.size(deliveryItem.audioChannelMapGroups)) {
            deliveryItem.audioChannelMapGroups = [];
        }

        deliveryItem.audioChannelMapGroups = _.sortBy(deliveryItem.audioChannelMapGroups, (channelMapGroup: JS5Object) => {
            return parseInt(channelMapGroup.index);
        });
        videoChannelMapGroup = _.find(deliveryItem.audioChannelMapGroups, {type: VIDEO_MAPPING_TYPE});
        if (!videoChannelMapGroup) {
            videoChannelMapGroup = createChannelMappingGroup(VIDEO_MAPPING_TYPE, 0);
        }
        this.getChannelGroupFromOutputChannel.cache.clear();
        onChannelGroupChanged();
        notifyRevertDataListeners();
    };

    this.initialize = (deliveryItem: JS5Object) => {
        videoChannelMapGroup = undefined;
        this.setDeliveryItem(deliveryItem);
    };

});
